import {MiddlewareType} from 'middlewares'
import {
  COUNTRY_LIST_FETCH,
  countryListDone,
  countryListError,
  countryListPending
} from 'modules/localization/actions/fetchCountryList'

import {getCountryListNames} from '@vio/core/src/localization/business/getCountriesList'

const middleware: MiddlewareType = store => next => async action => {
  const {dispatch} = store

  next(action)

  switch (action.type) {
    case COUNTRY_LIST_FETCH:
      dispatch(countryListPending())
      return getCountryListNames(action.language)
        .then(data => {
          dispatch(countryListDone(data))
        })
        .catch(error => {
          dispatch(countryListError(error))
        })

    default:
      break
  }
}

export default middleware
